import { EventTypes, track } from '@mc/track-event'

export const trackArticlePageClick = (copy: string) => {
  track(EventTypes.ARTICLE_PAGE_CLICK, {
    location: 'trailer_takeover',
    linkCopy: copy,
    textTag: 'a',
  })
}
